/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import axios from "axios";
import { getToken } from 'datastake-daf/src/helpers/Token';
import { useApp } from "../../../../helpers/user";
import { useGeneralContext } from "../../../../context/General";
import { getApiBaseUrl, getAppHeader } from "../../../../services/BaseService";

export default function useAjaxModal({
  name = {},
  namespace,
  isAjaxModal,
  formScope = 'modal',
}) {
  const { ajaxForms, changeAjaxForms } = useGeneralContext();
  const [isFetching, setIsFetching] = useState(isAjaxModal ? !ajaxForms[`${name}-${formScope}`] : false);
  const [form, setForm] = useState({});
  const app = useApp();
  const endpoint = `${getApiBaseUrl()}/${app}/form?namespace=${namespace}&scope=${formScope}`;

  useEffect(() => {
    if (isAjaxModal) {
      if (ajaxForms[`${name}-${formScope}`]) {
        setForm(ajaxForms[`${name}-${formScope}`]);
        setIsFetching(false);
      } else {
        axios.get(endpoint, {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            'ngrok-skip-browser-warning': true,
            ...getAppHeader(),
          },
        }).then(({ data }) => {
          if (data) {
            setForm(data);
            changeAjaxForms(`${name}-${formScope}`, data)
          }
          setIsFetching(false);
        }).catch((e) => {
          console.log(e);
          setIsFetching(false);
        });
      }
    }
  }, [formScope])

  return {
    form,
    isFetching,
    setIsFetching,
  };
}
